import { Button, TextInput } from '@mantine/core';
import { FC, useState } from 'react';

import Paragraph from '@/components/text/Paragraph.tsx';

interface Props {
    onConfirm: (ticket: string) => Promise<void>;
    onCancel?: () => void;
    initialTicket?: string;
}

const TicketInputModal: FC<Props> = ({ onConfirm, onCancel, initialTicket = '' }) => {
    const [is_loading, setIsLoading] = useState(false);
    const [ticket, setTicket] = useState<string>(initialTicket);

    const is_editing = initialTicket !== '';
    const is_unchanged = ticket === initialTicket;
    const is_empty = !ticket || ticket.trim() === '';

    const handleConfirm = async (): Promise<void> => {
        if (is_empty) return;

        setIsLoading(true);
        await onConfirm(ticket);
        setIsLoading(false);
    };

    return (
        <div className="flex flex-col space-y-4">
            {is_editing && (
                <Paragraph className="text-slate-600">
                    Die Ticketnummer wird sowohl im Termin als auch im Warteraum-Anzeigesystem aktualisiert.
                </Paragraph>
            )}

            {is_editing && (
                <TextInput
                    label="Aktuelle Ticketnummer"
                    value={initialTicket}
                    disabled
                    classNames={{ input: 'bg-slate-100' }}
                />
            )}

            <TextInput
                label={is_editing ? 'Neue Ticketnummer' : 'Ticketnummer'}
                value={ticket}
                onChange={(e) => setTicket(e.currentTarget.value.trim())}
                placeholder={is_editing ? 'Neue Ticketnummer eingeben' : undefined}
                error={
                    is_editing && is_unchanged && !is_empty
                        ? 'Die neue Ticketnummer muss sich von der alten unterscheiden'
                        : undefined
                }
            />

            <div className="mt-6 flex gap-2">
                <Button
                    variant="subtle"
                    color="gray"
                    className="w-full"
                    onClick={() => {
                        onCancel?.();
                    }}
                    disabled={is_loading}
                >
                    Abbrechen
                </Button>
                <Button
                    variant="filled"
                    className="w-full"
                    onClick={handleConfirm}
                    disabled={is_empty || (is_editing && is_unchanged)}
                    loading={is_loading}
                >
                    {is_editing ? 'Ticketnummer aktualisieren' : 'Weiter'}
                </Button>
            </div>
        </div>
    );
};

export default TicketInputModal;
